<!--
  description: generic checkbox which gets values for a specific 'set' from the store admin/form getter.
  note: although it is generic currently this is only used in one admin page at moment.
  todo: remodel to use mapState
-->
<template>
  <div
    class="form-check-block showbutton"
    :class="view"
    style="max-width: 26em; min-width:16em;"
  >
    <!-- HACK: we need this otherwise active is not set with initial values :( -->

    <!-- <pre style="display: none">{{ value }}</pre> -->

    <!-- its either this or a :key="record.duration" in
      the parent component but that issues the warning:
       Avoid using non-primitive value as key, use string/number value instead.

    Somehow we messed up the reactivity in this setup; the
    hiCheckbox components get rendered BEFORE the data is available and don't get updated unless we hack it like this.

    Is this because we use v-model in the parent component?

    See LearningActivityEditor.vue for <hiCheckbox> usage

    Update 7 aug 2019: by using a :key="recordLoaded" on the component and doing an ++ on this var when a LA is loaded we force a rerender.

    Still not very clean but nicer than it was


    -->

    <h5>
      <i class="fa" :class="icon" />&nbsp;
      {{ title || form.title }}
    </h5>

    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="Processing..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    />

    <ul style="background-color:inherit; border:0; padding:0">
      <li
        :key="i"
        v-for="(e, i) in $store.getters['forms'][set].options"
        style="height:auto"
      >
        <div class="hoverme" @click.alt.exact.prevent="doDelete(e.label)">
          <el-checkbox
            :label="e.label"
            v-model.lazy="active"
            @change="
              (e) => {
                if (view === 'why') {
                  sendUpdate()
                } else {
                  $emit('input', active)
                }
              }
            "
          />
        </div>

        <textarea
          v-if="view === 'why' && active && active.includes(e.label)"
          placeholder="Add the Why"
          v-model.lazy="why[e.label]"
          @change="
            (e) => {
              $emit('upWhy', sendUpdate())
            }
          "
          rows="8"
          cols="42"
        />
      </li>
    </ul>

    <span v-if="message" class="message ok">
      {{ message }}
    </span>

    <!-- BUTTON ONLY SHOWS WHEN BOX IS IN FOCUS !! -->
    <button
      v-if="!addNew && message === '' && add"
      @click="addNew = true"
      class="hi-button addbutton"
    >
      <i class="fa fa-plus" /> Add
    </button>

    <div v-if="addNew">
      <input v-model="newValue" placeholder="Add..." type="text" size="30/" />
      <button
        :disabled="!newValue.length > 0"
        @click="doAdd(newValue)"
        class="hi-button"
      >
        OK
      </button>
    </div>
    <!--  <pre>active: {{active}}</pre> -->
    <!--  <pre>value: {{value}}</pre> -->
  </div>
</template>
<script>
import { API } from "../tic"
export default {
  name: "HiCheckbox",
  //props: ['title', 'set', 'icon', 'view', 'add', 'value'],
  props: {
    title: {
      type: String,
      default: "",
    },

    set: {
      type: String,
      default: "",
    },

    icon: {
      type: String,
      default: "",
    },

    view: {
      type: String,
      default: "",
    },

    add: {
      type: Boolean,
      default: false,
    },

    value: {
      type: Array,
      default: () => {
        return []
      },
    },
  },

  watch: {
    // value: {
    //   immediate: true,
    //   handler: (e,a) => {
    //     console.log("wacther for value ****", e,a)
    //     return e
    //   }

    // },

    set: {
      immediate: true,
      handler: "getData",
    },
  },

  updated() {
    if (this.view !== "why") {
      this.active = this.value
    }
  },

  mounted() {
    //window.addEventListener('keydown', this.keyHandler)
    this.active = this.value
  },

  methods: {
    keyHandler(e) {},

    sendUpdate() {
      let vm = this
      // use vm.active to determine which checkboxes / why info
      // we should sent to the caller.
      let whys = {}
      vm.active.forEach((e) => {
        whys[e] = vm.why[e]
      })

      return { why: whys, set: vm.set }
    },
    doDelete(label) {
      let vm = this
      this.loading = true
      let really = confirm(`Delete ${label} ?`)
      if (really) {
        API.post(this.form.actions.delete.method, {
          value: label,
          field: this.form.actions.delete.field,
        }).then((resp) => {
          vm.$store.commit("admin/SET_FORMS", resp.data.data)
          vm.loading = false
        })
      }
      vm.loading = false
      vm.$message({ message: "Delete ignored.", type: "success" })
    },

    // nope () {
    //   this.message=''
    // },

    doAdd(label) {
      let vm = this
      this.newValue = ""
      this.addNew = false
      this.loading = true
      this.message = "Adding..."
      API.post(`/admin/add/form/${vm.form["node"]}`, {
        value: label,
        field: this.form.actions.add.field,
      }).then((resp) => {
        vm.$store.commit("admin/SET_FORMS", resp.data.data)
        vm.message = ""
        this.loading = false
        //setTimeout(() => {
        //  this.nope()
        //} , 1000)
      })
    },

    getData() {
      console.log("getData: ", this.set)
      this.form = this.$store.state.forms[this.set] || []
      // neem de waarden in v-model variabele ove r
      //this.active = this.value
    },
  },

  data() {
    return {
      loading: false,
      form: [],
      active: [],
      selected: null,
      addNew: false,
      newValue: "",
      message: "",
      why: {},
    }
  },
}
</script>
<style>
.addbutton {
  display: none;
  background-color: red;
}

.showbutton:hover .addbutton {
  display: block;
}
</style>
